import { EDruhAkcie } from 'enums/isin/udaje/druhAkcie';

const druhAkcieSelect = [
    {
        value: EDruhAkcie.KMEN,
        labelcz: 'ISIN_EMISE_AKCIE_DRUH_KMEN'
    },
    {
        value: EDruhAkcie.KUS,
        labelcz: 'ISIN_EMISE_AKCIE_DRUH_KMENK'
    },
    {
        value: EDruhAkcie.PRIOR,
        labelcz: 'ISIN_EMISE_AKCIE_DRUH_PRIOR'
    },
    {
        value: EDruhAkcie.PRIORKUS,
        labelcz: 'ISIN_EMISE_AKCIE_DRUH_PRIORK'
    },
    {
        value: EDruhAkcie.JINA,
        labelcz: 'ISIN_EMISE_AKCIE_DRUH_JINA'
    }
];
export const druhAkciePrikazSelect = [
    {
        value: EDruhAkcie.KMEN,
        labelcz: 'ISIN_EMISE_AKCIE_DRUH_PRIKAZ_KMEN'
    },
    {
        value: EDruhAkcie.KUS,
        labelcz: 'ISIN_EMISE_AKCIE_DRUH_PRIKAZ_KMENK'
    },
    {
        value: EDruhAkcie.PRIOR,
        labelcz: 'ISIN_EMISE_AKCIE_DRUH_PRIKAZ_PRIOR'
    },
    {
        value: EDruhAkcie.PRIORKUS,
        labelcz: 'ISIN_EMISE_AKCIE_DRUH_PRIKAZ_PRIORK'
    },
    {
        value: EDruhAkcie.JINA,
        labelcz: 'ISIN_EMISE_AKCIE_DRUH_PRIKAZ_JINA'
    }
];

export default druhAkcieSelect;
